import SecondaryButton from "./common/secondary-btn"
export default function HireUs({toggleModal, id})
{

const title="Hire a Stripe Expert Today!";
const subs ="Seeking experienced Stripe developer for seamless payment integration and customization.";

    return(
        <section className="relative section-1 mt-[120px] py-[50px] bg-[#F5F4FF] my-[70px]" style={{backgroundImage: "url(https://glocify.com/images/bannerblue.svg)", backgroundRepeat: "no-repeat",
            backgroundSize: "cover",  backgroundPosition:'bottom center'}}>
            <div className="container xl:px-0 lg:px-8 md:px-6 px-4 mx-auto">
                <div className="flex items-center relative md/lg:flex-row flex-col-reverse gap-[40px]">
                <div className="text-left md/lg:w-[45%] w-full" >
                    <h1 className='lg:text-[60px]   text-[35px] mb-0 font-bold text-white relative inline-block leading-[1.2]'>
                        {title}                      
                    </h1>
                    <p className=" text-white text-[16px] font-regular pt-[10px] max-w-[520px] ">
                        {subs}
                    </p>
                    <div  className="mt-[20px]">  <SecondaryButton  title="Hire Stripe Developer"  toggleModal={toggleModal}/></div>       
                </div>
                <div className="md/lg:w-[50%] w-full  pt-[30%] lg:pt[0]">
                <img className=" absolute  bottom-[65%]  lg:bottom-[10%]  md:bottom-[0%]  left-[0] right-[0] mx-auto md:left-[unset]  md:right-[unset] md:mx-0 lg:left-[unset]  lg:right-[unset] lg:mx-0 lg:max-w-[570px]  md:max-w-[370px]  max-w-[90%]" alt="Hire Stripe Developer" src="https://glocify.com/images/stripe-dev.png"/>
                </div>
                </div>
            </div> 
        </section>
    )
}